import { useRecoilState } from 'recoil';

import { locationState } from '@store';

/**
 * useGetGeoLocation: an intermediary hook to pull location data out of recoil
 * Slightly cleaner to use this than having to use recoil in every place it's needed
 */
export const useGetGeoLocation = () => {
  const [location] = useRecoilState(locationState);

  return {
    city: location.city,
    state: location.state,
    coords: {
      ...location.coords,
    },
    zipCode: location.zipCode,
    market: location.market,
    timeZone: location.timeZone,
  };
};
